import React, { useState } from 'react';
import styled from 'styled-components';
import Map from "../../pages/maps/map/index";
import { mediaMax } from "../../../styles/mediaQueries";

import { mediaMin } from "styles/mediaQueries";
import Regional from './regional';
import Commute from './commute';
import Row from './row';

const MapNavigation = styled.nav`
  width: 300px;
  display: flex;
  justify-content: space-between;
  ${mediaMax.tabletLandscape`
    width:60%;
  `};
  ${mediaMax.tablet`
    width:100%;
  `};
  button {
    background: none;
    border: 0;
    padding: 8px 0;
    cursor: pointer;
    font-size: 12px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    opacity: 0.3;
    transition: .4s ease-out;
    outline: none;
    &.active {
      border-bottom: 1px solid #000;
      opacity: 1;
    }
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .row-container {
    display: flex;
    position: absolute;
    width: 100%;
    margin: 0 auto;
    opacity: 0;
    visibility: hidden;
    transition: all 300ms ease;
    height: 100%;
    &.active {
      opacity: 1;
      visibility: visible;
    }
    img {
      width: 100%;
      margin: 0 auto;
      align-self: start;
      margin-bottom: 50px;
      ${mediaMin.tabletLandscape`
        height: auto;
      `}
    }
  }
  .neighborhood-container {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    opacity: 0;
    visibility: hidden;
    transition: all 300ms ease;
    flex-direction: column;
    overflow: hidden;
    position: absolute;
    &.active {
      opacity: 1;
      visibility: visible;
      overflow: initial;
    }
    img {
      align-self: center;
      margin-top: 2em;
      max-height: 90%;
      margin-bottom: 50px;
    }
    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .regional-container {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    opacity: 0;
    visibility: hidden;
    transition: all 300ms ease;
    flex-direction: column;
    overflow: hidden;
    position: absolute;
    &.active {
      opacity: 1;
      visibility: visible;
      overflow: initial;
    }
    img {
      align-self: center;
      margin-top: 26px;
      max-height: 85%;
      margin-bottom: 20px;
    }
    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .commute-container {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    opacity: 0;
    visibility: hidden;
    transition: all 300ms ease;
    flex-direction: column;
    overflow: hidden;
    position: absolute;
    &.active {
      opacity: 1;
      visibility: visible;
      overflow: initial;
    }
    img {
      align-self: center;
      margin-top: 26px;
      max-height: 90%;
      margin-bottom: 50px;
    }
    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

function Maps({ displayMobile }) {
  const [activeMap, toggleMap] = useState('row');

  return (
    <div className="full-height-container">
      <MapNavigation>
        <button className={activeMap === 'row' ? 'active' : null} onClick={() => toggleMap('row')}>
          ROW
        </button>
        <button
          className={activeMap === 'neighborhood' ? 'active' : null}
          onClick={() => toggleMap('neighborhood')}
        >
          NEIGHBORHOOD
        </button>
        <button
          className={activeMap === 'regional' ? 'active' : null}
          onClick={() => toggleMap('regional')}
        >
          REGIONAL
        </button>
        <button
          className={activeMap === 'commute' ? 'active' : null}
          onClick={() => toggleMap('commute')}
        >
          COMMUTE
        </button>
      </MapNavigation>
      <MapContainer displayMobile={displayMobile}>
        <div className={`row-container ${activeMap === 'row' ? 'active' : null}`}>
          <Row/>
        </div>
        <div className={`neighborhood-container ${activeMap === 'neighborhood' ? 'active' : null}`}>
          <Map/>
        </div>
        <div className={`regional-container ${activeMap === 'regional' ? 'active' : null}`}>
          <Regional/>
        </div>
        <div className={`commute-container ${activeMap === 'commute' ? 'active' : null}`}>
          <Commute/>
        </div>
      </MapContainer>
    </div>
  );
}

export default Maps;
